import { cva } from "class-variance-authority";

export { default as Feed } from "./Feed.vue";
export { default as FeedItem } from "./FeedItem.vue";

export const FeedTypes = Object.freeze({
    COMMENTS: "comments",
    ACTIVITY_LOG: "activity_log",
    TIME_LOG: "time_log",
    MATERIAL_LOG: "material_log",
});

export const feedVariants = cva(
    ["w-full", "flex", "flex-col", "grow", "shrink-0", "bg-primary"],
    {
        variants: {
            variant: {
                comments: ["justify-end", "p-5", "gap-4"],
                activity_log: ["p-5", "gap-2"],
                time_log: ["gap-2", "bg-tertiary"],
                material_log: ["gap-2", "bg-tertiary"],
            },
        },
    }
);

export const feedItemVariants = cva(["flex", "gap-1"], {
    variants: {
        variant: {
            comments: ["flex-col"],
            activity_log: ["flex-col", "pb-1"],
            time_log: ["flex-col", "pb-1"],
            material_log: ["flex-col", "pb-1"],
        },
    },
});
